import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const fetch_providersImage_state = {};
export const DATA_fetch_providersImage = createReducer(
  fetch_providersImage_state,
  {
    [types.FETCH_PROVIDERS_IMAGE](state, action) {
      let newState = fetch_providersImage_state;
      newState = action.value;
      return newState;
    }
  }
);

const fetch_providers_state = {};
export const DATA_fetch_providers = createReducer(fetch_providers_state, {
  [types.FETCH_PROVIDERS](state, action) {
    let newState = fetch_providers_state;
    newState = action.value;
    return newState;
  }
});

const fetch_filteredProviders_state = {};
export const DATA_fetch_filteredProviders = createReducer(
  fetch_filteredProviders_state,
  {
    [types.FETCH_FILTERED_PROVIDERS](state, action) {
      let newState = fetch_filteredProviders_state;
      newState = action.value;
      return newState;
    }
  }
);
